import React from "react";

export function ChartToolBar(props) {
    return <>
        <div className="time-ranges">
            {props.periods.map(props.callbackfn)}
        </div>
        <div className={"fixed-icons"}>
            <i className={"fa fa-pencil"} onClick={props.onClick}/>
            <i className={"fa fa-cog"} onClick={props.onClick1}/>
        </div>
    </>;
}